var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseEditableLayout',{staticClass:"container",attrs:{"panels":_vm.panels,"padding":10,"border-radius":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }